import { createContext, useReducer } from "react";

const ModalsContext = createContext();

let initialState = {
  modalData: {},
  showReportDatePicker: false,
  showReportInvoicePicker: false,
  showNotificationModal: false,
  showLoadingNotificationModal: false,
};

export const ActionType = {
  setShowReportDatePicker: "setShowReportDatePicker",
  setShowReportInvoicePicker: "setShowReportInvoicePicker",
  setShowNotificationModal: "setShowNotificationModal",
  setShowLoadingNotificationModal: "setShowLoadingNotificationModal",
};

function modalsReducer(state, action) {
  switch (action.type) {
    case ActionType.setShowReportDatePicker: {
      return {
        ...state,
        modalData: action.payload,
        showReportDatePicker: !state.showReportDatePicker,
      };
    }
    case ActionType.setShowReportInvoicePicker: {
      return {
        ...state,
        modalData: action.payload,
        showReportInvoicePicker: !state.showReportInvoicePicker,
      };
    }
    case ActionType.setShowNotificationModal: {
      return {
        ...state,
        modalData: action.payload,
        showNotificationModal: !state.showNotificationModal,
      };
    }
    case ActionType.setShowLoadingNotificationModal: {
      return {
        ...state,
        modalData: action.payload,
        showLoadingNotificationModal: !state.showLoadingNotificationModal,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function ModalsProvider({ children }) {
  const [state, dispatch] = useReducer(modalsReducer, initialState);
  const value = { state, dispatch };
  return <ModalsContext.Provider value={value}>{children}</ModalsContext.Provider>;
}

export { ModalsProvider, ModalsContext };
